import { Outlet } from "@tanstack/react-router";
import { useState } from "react";
import { Confirmer, Toaster } from "@/components/kit";
import { NotificationProvider } from "../providers/NotificationProvider";
import { OperationalAlertsSync } from "@/modules/alerts/presentation/OperationalAlertsSync";
import { ThemeProvider } from "../providers/ThemeProvider";
import { UpdateBanner } from "./UpdateBanner";
import { InstallPrompt } from "./InstallPrompt";

export function RootLayout() {
  const [bannerVisible, setBannerVisible] = useState(false);

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      storageKey="ui-theme"
    >
      <NotificationProvider>
        <UpdateBanner onVisibilityChange={setBannerVisible} />
        <InstallPrompt />
        <div className={`min-h-screen ${bannerVisible ? "pt-16" : ""}`}>
          <Outlet />
        </div>
        <Confirmer />
        <Toaster />
      </NotificationProvider>
    </ThemeProvider>
  );
}
